import React from "react"
import Navbar from "./Navbar.tsx"
import Markdown from "react-markdown"

export default function Home() {
    return (
        <div>
            <Navbar/>
            <Markdown className={"markdown"}>{`# Home \n *WIP* `}</Markdown>
        </div>
    )
}